// src/hooks/useSocket.js
import { useEffect } from "react";
import { connectSocket } from "../services/socket";
import { tokenDecodeSafe } from "../utils/helper";

export function useSocket() {
  useEffect(() => {
    const token = localStorage.getItem("us_st_d");
    if (!token) return;

    const decoded = tokenDecodeSafe();
    const userId = decoded?.data?.user?._id;

    if (userId) {
      connectSocket(token, userId);
    }
  }, []);
}